class EoSParticipant{
    constructor(id, color, c1x, c1y, c2x, c2y)
    {
        this.c1x = c1x;
        this.c1y = c1y;
        this.c2x = c2x;
        this.c2y = c2y;
        this.id = id;
        this.color = color;
        this.device = "viewer";
    }

    get json_dict()
    {
        return {
            "id": this.id, 
            "color": this.color,
            "device": this.device, 
            "cursors": [
                {"x": this.c1x, "y": this.c1y},
                {"x": this.c2x, "y": this.c2y},
            ]};
    }

    distance(conversionFactor)
    {
        return Math.sqrt((this.c1y - this.c2y)**2 + (this.c1x - this.c2x)**2) / conversionFactor;
    }

    draw(ctx, conversionFactor, rotated) {
        // Drawing settings
        ctx.strokeStyle = this.color;
        ctx.fillStyle = this.color;
        ctx.lineWidth = 2;
        ctx.font = "24px sans-serif";
        ctx.textBaseline = "bottom";
        ctx.textAlign = "center";
        ctx.setLineDash([]);

        // Draw the inner circles

        // Draw cursor 1
        if (this.c1x > 0 && this.c1y > 0)
        {
            ctx.beginPath();
            ctx.arc(this.c1x, this.c1y, 3, 0, 2 * Math.PI);
            ctx.fill();

            ctx.beginPath();
            ctx.arc(this.c1x, this.c1y, 11, 0, 2 * Math.PI);
            ctx.stroke();
        }

        // Draw cursor 2
        if (this.c2x > 0 && this.c2y > 0)
        {
            ctx.strokeRect(this.c2x - 10, this.c2y - 10, 20, 20);

            ctx.beginPath();
            ctx.arc(this.c2x, this.c2y, 3, 0, 2 * Math.PI);
            ctx.fill();
        }

        // Draw dotted line and text only if both cursors are visible
        if (this.c1x > 0 && this.c1y > 0 && this.c2x > 0 && this.c2y > 0)
        {
            // Draw dotted line
            ctx.setLineDash([5, 5]);
            ctx.beginPath();
            ctx.moveTo(this.c1x, this.c1y);
            ctx.lineTo(this.c2x, this.c2y);
            ctx.stroke();

            // Draw text if only conversion factor is set
            if (conversionFactor > 0.001)
            {
                // Draw text
                const distanceText = `${this.distance(conversionFactor).toFixed(1)  } cm`;
                const textDims = ctx.measureText(distanceText);
                const textWidth = textDims.width;

                // Draw it rotated
                ctx.save();
                // Rotate around center of line
                ctx.translate((this.c1x + this.c2x) / 2, (this.c1y + this.c2y) / 2);
                // When rotated, change the flipping point
                if (rotated)
                    ctx.rotate(Math.atan(-(this.c1x - this.c2x) / (this.c1y - this.c2y)) + 3 * Math.PI/2);
                // Else, just the normal tangent
                else
                    ctx.rotate(Math.atan((this.c1y - this.c2y) / (this.c1x - this.c2x)));
                
                // If text is shorter than the line
                if ((textWidth + 20)**2 < ((this.c1y - this.c2y)**2 + (this.c1x - this.c2x)**2))
                {
                    ctx.fillStyle = 'rgba(0, 0, 0, 0.4)';
                    ctx.fillRect(-textDims.actualBoundingBoxLeft - 5, -textDims.actualBoundingBoxAscent - 5, textDims.width + 10, textDims.actualBoundingBoxAscent + textDims.actualBoundingBoxDescent + 10);

                    ctx.fillStyle = 'white';
                    ctx.fillText(distanceText, 0, 0);
                }
                // If it will be longer, then raise it a bit up so it doesn't combine with the cursors
                else
                {
                    ctx.fillStyle = 'rgba(0, 0, 0, 0.4)';
                    ctx.fillRect(-textDims.actualBoundingBoxLeft - 5, -textDims.actualBoundingBoxAscent - 10 -5, textDims.width + 10, textDims.actualBoundingBoxAscent + textDims.actualBoundingBoxDescent + 10);

                    ctx.fillStyle = 'white';
                    ctx.fillText(distanceText, 0, -10);
                }
                ctx.restore();
            }
        }
    }
}

export default EoSParticipant;
